import {Flex, SimpleGrid, VStack, Text} from '@tempo/core';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import type {FC} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import type {TranslationKey} from 'globalTranslations';
import {Image, type ImageProps} from '@app/components/Image';

export type Item = {
	href: string;
	src: ImageProps['src'];
	title?: string;
	cardTitle?: string;
};

export type Config = {
	title?: TranslationKey | string;
	description?: TranslationKey;
	items: Item[];
	bottomDescription?:
		| TranslationKey
		| string
		| {
				key: TranslationKey;
				sprintf: string[];
		  };
};

type Props = {
	configs: Config[];
};

const GridSection: FC<Props> = ({configs}) => {
	const {t} = useTranslation({ns: ['common', 'creators']});
	return (
		<VStack gap={{base: 'size.s', md: 'size.m'}} w="100%">
			{configs &&
				configs.map((config, i) => {
					return (
						<VStack
							alignItems="center"
							key={`${config.title}-${i}`}
							spacing={8}
						>
							{config.title && (
								<LandingHeading textAlign="center" as="h3">
									{t(config.title as TranslationKey)}
								</LandingHeading>
							)}
							{config.description && (
								<LandingParagraph textAlign="center" maxW="100ch">
									{t(config.description)}
								</LandingParagraph>
							)}
							<SimpleGrid
								gap={{base: 'size.s', md: 'size.m'}}
								columns={{base: 2, sm: 3}}
							>
								{config.items.map((item) => {
									return (
										<a key={item.href} href={item.href}>
											<Flex
												w="150px"
												h="150px"
												border="solid 1px"
												padding="size.s"
												borderColor="border.accent.primary.default"
											>
												{item.src && (
													<Image
														objectFit="contain"
														alt={'logo partner ' + i}
														width={150}
														height={150}
														src={item.src}
													/>
												)}

												{item.cardTitle && (
													<Text
														as="h3"
														fontFamily="Deezer"
														fontSize="md"
														color="text.neutral.secondary.default"
														alignSelf="center"
														margin="auto"
													>
														{item.cardTitle}
													</Text>
												)}
											</Flex>

											{item.title && (
												<Text
													as="h3"
													mt={2}
													fontFamily="Deezer"
													fontSize="md"
													color="text.neutral.secondary.default"
													textAlign="left"
												>
													{item.title}
												</Text>
											)}
										</a>
									);
								})}
							</SimpleGrid>
							{config.bottomDescription && (
								<LandingParagraph
									dangerouslySetInnerHTML={{
										__html:
											typeof config.bottomDescription === 'string'
												? t(config.bottomDescription as TranslationKey)
												: t(config.bottomDescription.key, {
														sprintf: config.bottomDescription.sprintf,
													}),
									}}
								/>
							)}
						</VStack>
					);
				})}
		</VStack>
	);
};

export default GridSection;
